import React from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';

import PropTypes from 'prop-types';

const Header = props => {
  const { button, period, tabs } = props;
  return (
    <>
      <Stack direction="row" justifyContent="space-between">
        {period}
        {button}
      </Stack>
      <Box mt={2}>{tabs}</Box>
    </>
  );
};

Header.propTypes = {
  button: PropTypes.node,
  period: PropTypes.node.isRequired,
  tabs: PropTypes.node,
};

Header.defaultProps = {
  button: null,
  tabs: null,
};

export default Header;
